import { UserTeamType } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const userTeamTypeMessages = defineMessages({
  mediations: {
    defaultMessage: 'Mediations',
    description: 'user team type title',
  },
  negotiations: {
    defaultMessage: 'Negotiations',
    description: 'user team type title',
  },
  operations: {
    defaultMessage: 'Operations',
    description: 'user team type title',
  },
  support: {
    defaultMessage: 'Support',
    description: 'user team type title',
  },
})

export function translateUserTeamType(intl: IntlShape, userTeamType: UserTeamType): string {
  switch (userTeamType) {
    case UserTeamType.MEDIATIONS:
      return intl.formatMessage(userTeamTypeMessages.mediations)
    case UserTeamType.NEGOTIATIONS:
      return intl.formatMessage(userTeamTypeMessages.negotiations)
    case UserTeamType.OPERATIONS:
      return intl.formatMessage(userTeamTypeMessages.operations)
    case UserTeamType.SUPPORT:
      return intl.formatMessage(userTeamTypeMessages.support)
  }
}
